import {customSize} from '../design/configurator/room/custom-layout'
import {BED_OPTIONS} from '../design/configurator/room/beds'
import {INITIAL_ROOM} from '../design/configurator/room/model'
import type {ConfiguratorSnapshot} from '../design/configurator/integration'
import {hasBasicUpgrades,type BasicUpgrades} from '../../../../shared/basicUpgrades'
export function photoPurchaseSnapshot(choices: number[], upgrades: BasicUpgrades[] = [], finishes: ('matte_white'|'gloss_white'|'custom_color')[] = [], colorCodes: (string|undefined)[] = []): ConfiguratorSnapshot {
  return {
    version: 1,
    room: { ...INITIAL_ROOM },
    openings: [],
    basicUpgrades: choices.map((_,i)=>({...upgrades[i],bedId:`photo-bunk-${i}`})).filter(hasBasicUpgrades),
    beds: [...choices.map((choice, i) => {
      if (!BED_OPTIONS[choice]) throw new Error("Choose a valid bunk.");
      return {
        ...BED_OPTIONS[choice],
        id: `photo-bunk-${i}`,
        height: 80,
        basicFinish: finishes[i],
        basicColorCode: finishes[i]==='custom_color'&&/^SW\d{4}$/.test(colorCodes[i]??'')?colorCodes[i]:undefined,
        ladder: !upgrades[i]?.stairs,
        x: 0,
        y: 0,
        rotation: 0 as const,
      };
    }),...choices.flatMap((_,i)=>upgrades[i]?.stairs?[{id:`stairs-${i}`,name:'Staircase with standard niches',kind:'stairs' as const,x:0,y:0,width:24,depth:81,height:80,rotation:0 as const,servesBedIds:[`photo-bunk-${i}`]}]:[])],
    capacity: {
      current: null,
      planned: null,
      rental: false,
      storageRequested: false,
      priorities: [],
    },
  };
}

/** Catalog Ernst scope for pricing; these are model dimensions, not room measurements. */
export function ernstPurchaseSnapshot(): ConfiguratorSnapshot {
  const {width,depth,height}=customSize('rosemary',194);
  return {
    version:1,
    room:{...INITIAL_ROOM,width:Math.max(INITIAL_ROOM.width,width),height:Math.max(INITIAL_ROOM.height,height)},
    openings:[],
    beds:[{id:'inspired-ernst',name:'Ernst',kind:'custom',customStyle:'rosemary',mattressConfig:'twin_full',stairStyle:'enclosed',width,depth,height,x:0,y:0,rotation:0}],
    capacity:{current:null,planned:null,rental:false,storageRequested:false,priorities:[]},
  };
}
